export var ALL_HOME_SECTION_IDS = {
  FEATURED_CONTENT_ID: 'featured',
  UPCOMING_ID: 'upcoming',
  SHARED_ID: 'shared',
  TOPICS_ID: 'topics',
  TRENDING_ID: 'trending',
  YOU_MIGHT_LIKE_ID: 'recommendations',
  RECENTLY_VIEWED_ID: 'recentlyViewed',
  RECENTLY_ADDED_ID: 'recentlyAdded'
};
var FEATURED_CONTENT_ID = ALL_HOME_SECTION_IDS.FEATURED_CONTENT_ID,
  UPCOMING_ID = ALL_HOME_SECTION_IDS.UPCOMING_ID,
  SHARED_ID = ALL_HOME_SECTION_IDS.SHARED_ID,
  TRENDING_ID = ALL_HOME_SECTION_IDS.TRENDING_ID,
  YOU_MIGHT_LIKE_ID = ALL_HOME_SECTION_IDS.YOU_MIGHT_LIKE_ID,
  RECENTLY_VIEWED_ID = ALL_HOME_SECTION_IDS.RECENTLY_VIEWED_ID,
  RECENTLY_ADDED_ID = ALL_HOME_SECTION_IDS.RECENTLY_ADDED_ID;
export var DEFAULT_INCLUDED_ORDERED_HOME_SECTION_IDS = [FEATURED_CONTENT_ID, UPCOMING_ID, SHARED_ID, TRENDING_ID, YOU_MIGHT_LIKE_ID, RECENTLY_VIEWED_ID, RECENTLY_ADDED_ID];